import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Table, Button, Form, Pagination, InputGroup, Modal } from 'react-bootstrap';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import axios from 'axios';
import { API_ENDPOINTS } from '../config'; // Import API endpoints from '../config'
import { BsTrash, BsSearch, BsSortDown, BsSortUp } from 'react-icons/bs';

const Orders = () => {
  const [orders, setOrders] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [ordersPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortField, setSortField] = useState('orderId');
  const [sortDirection, setSortDirection] = useState('asc');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedOrderId, setSelectedOrderId] = useState(null);

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(API_ENDPOINTS.getAllOrders, {
        headers: { token }
      });

      setOrders(response.data.orders);
    } catch (error) {
      console.error('Error fetching orders:', error);
    }
  };

  // Sorting function
  const sortOrders = (field) => {
    if (field === sortField) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortDirection('asc');
    }
  };

  // Apply sorting and filtering
  const sortedAndFilteredOrders = orders
    .filter(order => 
      order.orderId.toLowerCase().includes(searchTerm.toLowerCase()) ||
      order.userId.toLowerCase().includes(searchTerm.toLowerCase()) ||
      order.status.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .sort((a, b) => {
      if (a[sortField] < b[sortField]) return sortDirection === 'asc' ? -1 : 1;
      if (a[sortField] > b[sortField]) return sortDirection === 'asc' ? 1 : -1;
      return 0;
    });

  // Pagination
  const indexOfLastOrder = currentPage * ordersPerPage;
  const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
  const currentOrders = sortedAndFilteredOrders.slice(indexOfFirstOrder, indexOfLastOrder);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Show delete confirmation popup
  const handleDeleteClick = (orderId) => {
    setSelectedOrderId(orderId);
    setShowDeleteModal(true);
  };

  // Confirm delete order
  const confirmDeleteOrder = async () => {
    try {
      const token = localStorage.getItem('token');
      await axios.delete(API_ENDPOINTS.deleteOrder, {
        headers: { token, orderid: selectedOrderId }
      });

      // Refresh the orders list after deletion
      fetchOrders();
    } catch (error) {
      console.error('Error deleting order:', error);
    } finally {
      setShowDeleteModal(false); // Close the modal
    }
  };

  const handleSelectChange = (e, rowId) => {
    //console.log(rowId,'---',e.target.value);
     (async () => {
        try {
          await axios.post(API_ENDPOINTS.updateOrder, {
            orderId: rowId,statusval:e.target.value 
          });
          window.location.reload(false);
        
        } catch (error) { 
          console.error('Error deleting order:', error);
        } finally {
          setShowDeleteModal(false); // Close the modal
        }
      })();
    
  };

  return (
    <div className="d-flex">
      <Sidebar style={{ position: 'fixed', top: 0, bottom: 0, left: 0, width: '250px', zIndex: 1000 }} />
      <div style={{  width: 'calc(100%)', height: 'calc(100vh)', overflowY: 'auto' }}>
        <Header style={{ position: 'fixed', top: 0, left: '250px', width: 'calc(100% - 250px)', zIndex: 1000 }} />
        <Container fluid className="mt-3">
          <Row>
            <Col>
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h2>Orders</h2>
              </div>
              <InputGroup className="mb-3">
                <InputGroup.Text><BsSearch /></InputGroup.Text>
                <Form.Control
                  placeholder="Search orders..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </InputGroup>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th onClick={() => sortOrders('orderId')}>
                      Order ID {sortField === 'orderId' && (sortDirection === 'asc' ? <BsSortUp /> : <BsSortDown />)}
                    </th>
                    <th onClick={() => sortOrders('userId')}>
                      User ID {sortField === 'userId' && (sortDirection === 'asc' ? <BsSortUp /> : <BsSortDown />)}
                    </th>
                    <th onClick={() => sortOrders('status')}>
                      Status {sortField === 'status' && (sortDirection === 'asc' ? <BsSortUp /> : <BsSortDown />)}
                    </th>
                    <th onClick={() => sortOrders('totalAmount')}>
                      Total Amount {sortField === 'totalAmount' && (sortDirection === 'asc' ? <BsSortUp /> : <BsSortDown />)}
                    </th>
                    <th>Products</th>
                    <th>Change Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {currentOrders.map((order) => (
                    <tr key={order._id}>
                      <td>{order.orderId}</td>
                      <td>{order.userId}</td>
                      <td>{order.status.toUpperCase()}</td>
                      <td>${order.totalAmount ? order.totalAmount.toFixed(2) : 'N/A'}</td>
                      <td>
                        {order.products && order.products.map((product, index) => (
                          <div key={index}>
                            {product.productName} (x{product.quantity}) - ${product.productPrice ? product.productPrice.toFixed(2) : 'N/A'}
                          </div>
                        ))}
                      </td>
                      <td>
                        <select value={order.status}  onChange={(e) => handleSelectChange(e, order.orderId)}>
                        <option value="">-- Select Status --</option>
                        <option value="confirmed">Confirmed</option>
                        <option value="completed">Completed</option>
                        <option value="cancelled">Cancelled</option>
                      </select>
                      </td>
                      <td className="d-flex align-items-center">
                        <Button variant="danger" onClick={() => handleDeleteClick(order.orderId)}>
                          <BsTrash />
                        </Button>
                        
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <Pagination>
                {[...Array(Math.ceil(sortedAndFilteredOrders.length / ordersPerPage)).keys()].map(number => (
                  <Pagination.Item key={number + 1} active={number + 1 === currentPage} onClick={() => paginate(number + 1)}>
                    {number + 1}
                  </Pagination.Item>
                ))}
              </Pagination>
            </Col>
          </Row>
        </Container>

        {/* Delete Confirmation Modal */}
        <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Confirm Delete</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are you sure you want to delete this order?
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
              Cancel
            </Button>
            <Button variant="danger" onClick={confirmDeleteOrder}>
              Delete
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
};

export default Orders;
